<template>
  <div class="accordion-item border border-black/10 on-dark:border-white/10 rounded-lg overflow-hidden">
    <button
      :id="panelId + '-header'"
      type="button"
      class="accordion-header w-full px-6 py-4 text-left flex justify-between items-center hover:bg-black/5 on-dark:hover:bg-white/5 transition-colors"
      :aria-expanded="open"
      :aria-controls="panelId"
      @click="toggle"
    >
      <span class="text-lg font-semibold">{{ title }}</span>
      <svg
        class="w-5 h-5 transition-transform duration-200"
        :class="{ 'rotate-180': open }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        v-show="open"
        :id="panelId"
        role="region"
        :aria-labelledby="panelId + '-header'"
        class="accordion-content"
      >
        <div class="px-6 py-4 prose prose-lg max-w-none">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
let accordionUid = 0;

export default {
  name: 'AccordionItem',
  props: {
    title: {
      type: String,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: this.defaultOpen,
      panelId: 'accordion-panel-' + ++accordionUid
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.transition = 'height 0.3s ease'
    },
    afterEnter(el) {
      // Feste Pixel-Höhe nach der Animation lösen, sonst clippt der Inhalt,
      // wenn er nachträglich wächst (z.B. spät ladende Bilder im offenen Panel).
      el.style.height = 'auto'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.transition = 'height 0.3s ease'
      el.style.height = '0'
    }
  }
}
</script>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
}
</style>